import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { socket } from '../socket';
import VoiceChat from './VoiceChat'; 
import './ChatBox.css';

const ChatBox = () => {
  const { user } = useAuth();
  const [text, setText] = useState('');
  const [messages, setMessages] = useState([]);
  const [status, setStatus] = useState('⌛ Waiting for someone who feels like you…');
  const [partnerName, setPartnerName] = useState('');
  const [isTyping, setIsTyping] = useState(false);

  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  useEffect(() => {
    if (!user) return;

    socket.connect();
    const moodSentence = prompt("How are you feeling today?");
    socket.emit('join', { username: user.username, moodSentence });

    socket.on('status', (msg) => setStatus(msg));
    socket.on('partnerName', (name) => setPartnerName(name));
    socket.on('receiveMessage', (msg) => setMessages((prev) => [...prev, msg]));
    socket.on('partnerTyping', () => {
      setIsTyping(true);
      setTimeout(() => setIsTyping(false), 2000);
    });

    return () => {
      socket.off('status');
      socket.off('receiveMessage');
      socket.off('partnerTyping');
      socket.off('partnerName');
      socket.disconnect();
    };
  }, [user]);

  const handleSend = () => {
    if (text.trim()) {
      socket.emit('sendMessage', text);
      setText('');
    }
  };

  const handleTyping = () => {
    socket.emit('typing');
  };

  const handleSkip = () => {
    setMessages([]);
    setStatus('⌛ Waiting for someone who feels like you…');
    setPartnerName('');
    socket.emit('skipChat');
  };

  return (
    <div className="chatbox-center-bg">
      <div className="chatbox-card">

        {/* Header */}
        <div className="chatbox-header">
          <div className="chatbox-userpic">
            {user?.username ? user.username[0].toUpperCase() : '?'}
          </div>

          <div className="chatbox-info-col">
            <div className="chatbox-welcome">
              Welcome <span style={{ color: '#a78bfa' }}>{user?.username}</span>
            </div>

            <div className="chatbox-connected">
              {partnerName ? (
                <>
                  Connected to <strong style={{ color: '#a78bfa', marginLeft: '4px' }}>{partnerName}</strong>
                </>
              ) : (
                <span style={{ opacity: 0.7 }}>{status}</span>
              )}
            </div>
          </div>
        </div>

        {/* Messages */}
        <div className="chatbox-messages">
          {messages.map((msg, i) => {
            const isMe = msg.sender === user.username;
            return (
              <div key={i} className={`chatbox-bubble ${isMe ? 'me' : 'other'}`}>
                <span className="chatbox-sender-name">
                  {isMe ? 'You' : msg.sender}
                </span>
                {msg.content}
              </div>
            );
          })}

          {isTyping && partnerName && (
            <div className="chatbox-typing">{partnerName} is typing…</div>
          )}

          <div ref={messagesEndRef} />
        </div>

        {/* Controls */}
        <div className="chatbox-controls">
          <button className="skip" onClick={handleSkip}>
            <i className="fas fa-forward"></i>
          </button>

          <input
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={handleTyping}
            onKeyPress={(e) => e.key === 'Enter' && handleSend()}
            placeholder="Type a message..."
          />
                  <button className="send" onClick={handleSend}>
            <i className="fas fa-paper-plane"></i>
          </button>


          <VoiceChat />

          {/* <button className="send" onClick={handleSend}>
            <i className="fas fa-paper-plane"></i>
          </button> */}
        </div>

      </div>
    </div>
  );
};

export default ChatBox;
